export default __webpack_public_path__ + "static/media/ec598369-4d91-4a16-9db3-6654f68d3c28.f550f9e2.woff2";